import { COLOR_OPCION } from "../../constants/constants";

export const normalizePreguntasExamenesAcademia = (examenes) => {
  let preguntasExamenesAcademiaNormalizer = examenes;

  if (examenes && Array.isArray(examenes) && examenes.length > 0) {
    preguntasExamenesAcademiaNormalizer = examenes.map((exam) => {
      const newExam = {
        ...exam,
        selected: false,
      }
      return newExam
    })
  }

  return preguntasExamenesAcademiaNormalizer
}

export const normalizeRecuentoMaterias = (recuentoMaterias) => {
  let recuentoMateriasNormalizer = recuentoMaterias;
  let materias = recuentoMaterias?.materias || [];
  let casosClinicos = recuentoMaterias?.casosClinicos || [];

  if (materias && Array.isArray(materias) && materias.length > 0) {
    materias = materias.map((materia) => {
      const newMaterias = {
        ...materia,
        numPreguntasSel: 0,
      }
      return newMaterias
    })
  }

  if (casosClinicos && Array.isArray(casosClinicos) && casosClinicos.length > 0) {
    casosClinicos = casosClinicos.map((casoClinico) => ({
      ...casoClinico,
      numPreguntasSel: 0,
    }))
  }

  recuentoMateriasNormalizer = {
    ...recuentoMaterias,
    materias,
    casosClinicos
  }

  return recuentoMateriasNormalizer
}

export const normalizeExamen = (examen, tipo, isErroneas) => {
  let examenNormalizer = examen;

  if (examenNormalizer && Array.isArray(examenNormalizer) && examenNormalizer.length > 0) {
    examenNormalizer = examenNormalizer.map((pregunta) => {
      let respuestas = pregunta.respuestas;
      const newExamen = {
        ...pregunta,
        selected: false,
        dudosa: false,
      }
      if (pregunta && pregunta.respuestas && Array.isArray(pregunta.respuestas) && pregunta.respuestas.length > 0) {
        respuestas =  pregunta.respuestas.map((respuesta) => {
          const newRespuesta = {
            ...respuesta,
            colorOpcion: COLOR_OPCION.NADA,
          }
          return newRespuesta;
        })
      }
      newExamen.respuestas = respuestas;
      return newExamen
    })
    examenNormalizer[0].selected = true;
  }

  return {
    examen: examenNormalizer,
    tipo,
    isErroneas,
  }
}

export const normalizeMateriasErroneas = (materias) => {

  if (materias && Array.isArray(materias) && materias.length > 0) {
    materias = materias.map((materia) => {
      const newMaterias = {
        ...materia,
        numPreguntasSel: 0,
      }
      return newMaterias
    })
  }

  return materias;
}
